import ToolingLocations from './ToolingLocations';

export default ToolingLocations;



// WEBPACK FOOTER //
// ./src/pages/ToolingLocations/index.jsx